<template>
  <div id="RemoveLoggedIndirectHours">
    <v-btn icon :ripple="false"  small slot="activator" @click="showRemoveIndirectHoursDialog(user)" >
      <v-icon color="red"  >mdi-delete</v-icon>
    </v-btn>
    <v-dialog
      v-model="RemoveIndirectHoursDialog"
      width="400"
      persistent
      style="borderRadius:5px; zIndex:2"
    >
        <v-card >
           <v-toolbar  color="red elevation-0" dark>
            <v-icon color="white ">mdi-delete</v-icon>
            <v-toolbar-title class="white--text ml-1">Remove Hours </v-toolbar-title>

          </v-toolbar>
        
          <v-card-text class="pb-0">
          Are you sure you want to remove {{loggedHour.hours}} hours?
         
          </v-card-text>
        

       
          <v-card-actions class="pt-1"> 
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.native="RemoveIndirectHoursDialog = false">Cancel</v-btn>
          <v-btn color="red"  small text @click.native="removeindirectHours()">Remove</v-btn>
        </v-card-actions>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
  </div>

</template>

<script>
  export default {
    props: ['indirectHoursInfo', 'loggedHour'],
     data() {
      return {
        modal: false,
        alert: false,
        RemoveIndirectHoursDialog: false,
      }
    },
    methods: {
      showRemoveIndirectHoursDialog(user) {
        if(user !== null && user !== undefined ){
          this.RemoveIndirectHoursDialog = true
        }
        else {
          this.alert = true
          console.log('not logged in')
        }
      },
      removeindirectHours () {
     
        const loggedIndirectHours = {
         loggedHourId : this.loggedHour.id,
         indirectHoursId: this.indirectHoursInfo.id
        }
        console.log(loggedIndirectHours)
        this.$store.dispatch('setRemoveLoggedIndirectHours', loggedIndirectHours)
        this.RemoveIndirectHoursDialog = false
        
      }
    },
    computed : {
      user () {
        return this.$store.getters.user
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/ExperienceHours/IndirectHours/EditLoggedHours/RemoveLoggedIndirectHours.vue